define(['jquery'], function ($) {
    'use strict';

    return function stickyMenu() {
        let menuItem = $('.mega-menu');
        let stickyOffset = menuItem.offset().top;

        if ($(window).width() > 768) {
            $(window).scroll(function() {
                scroll = $(window).scrollTop();
            
                if (scroll >= stickyOffset) {
                    menuItem.css({"position": "fixed", 
                    "top": "0", 
                    "left": "0", 
                    "width": "100%", 
                    "box-shadow": "0 3px 10px rgba(0,0,0, 0.15)", 
                    "-webkit-box-shadow": "0 3px 10px rgba(0,0,0, 0.15)", 
                    "-moz-box-shadow": "0 3px 10px rgba(0,0,0, 0.15)"});
                }
                else {
                    menuItem.css({"position": "relative", 
                    "top": "initial", 
                    "left": "initial", 
                    "width": "initial",
                    "box-shadow": "none", 
                    "-webkit-box-shadow": "none", 
                    "-moz-box-shadow": "none"});
                }
            });
        }
    }
});
